import React from 'react';

function pct(used, total) {
  if (!total || total <= 0) return 0;
  return Math.min(100, Math.round((used / total) * 100));
}

function barColor(p) {
  if (p >= 90) return '#ff6b6b';
  if (p >= 70) return '#ffa552';
  return '#63d282';
}

function UsageRow({ icon, label, used, total, unit, note }) {
  const p     = pct(used, total);
  const color = barColor(p);
  const free  = total ? Math.max(0, total - used) : null;

  return (
    <div className="usage-bars-row">
      <div className="usage-bars-label">
        <span>{icon} {label}</span>
        <span className="usage-bars-numbers">
          {used !== null && used !== undefined
            ? total
              ? `${used} / ${total} ${unit}`
              : `${used} ${unit}`
            : '—'}
        </span>
      </div>
      {total > 0 && (
        <div className="usage-bars-track">
          <div className="usage-bars-fill"
            style={{ width: `${p}%`, background: color }} />
        </div>
      )}
      {note && <div className="usage-bars-note">{note}</div>}
      {free !== null && p < 90 && (
        <div className="usage-bars-free">
          {free} {unit} available
        </div>
      )}
      {p >= 90 && (
        <div className="usage-bars-warning">
          Almost full — upgrade to unlock more capacity
        </div>
      )}
    </div>
  );
}

function UsageBars({ quota, storageUsedGb, fileCount }) {
  if (!quota) return null;

  const tier       = quota.tier || 'trial';
  const isTrial    = quota.trial === true;
  const usedGb     = parseFloat(storageUsedGb || 0).toFixed(2);
  const storageGb  = quota.storage_gb || 25;
  const aiMonth    = quota.ai_labels_used_month || 0;
  const aiMonthMax = quota.ai_labels_per_month || 500;
  const aiDay      = quota.ai_labels_used_day || 0;
  const aiDayMax   = quota.ai_labels_per_day || 100;

  const monthPct = pct(aiMonth, aiMonthMax);
  const dayPct   = pct(aiDay, aiDayMax);

  return (
    <div className="usage-bars-card">
      <div className="usage-bars-header">
        <span className="usage-bars-title">📊 Your Usage</span>
        <span className="usage-bars-tier">{tier.charAt(0).toUpperCase() + tier.slice(1)}</span>
      </div>

      <UsageRow
        icon="📦" label="Storage"
        used={usedGb} total={storageGb} unit="GB"
      />

      <UsageRow
        icon="🏷️" label="AI classifications this month"
        used={aiMonth} total={aiMonthMax} unit="ops"
        note={isTrial && monthPct >= 70
          ? "Upgrade for higher monthly AI volume"
          : null}
      />

      <UsageRow
        icon="⚡" label="AI classifications today"
        used={aiDay} total={aiDayMax} unit="ops"
        note={isTrial && dayPct >= 70
          ? "Approaching today's AI limit — upgrade to lift this cap"
          : null}
      />

      <div className="usage-bars-row">
        <div className="usage-bars-label">
          <span>📁 Files stored</span>
          <span className="usage-bars-numbers">{fileCount} files</span>
        </div>
      </div>

      {isTrial && (
        <div className="usage-bars-trial-note">
          💡 Trial limits are modest by design — every capability is real and working.
          Upgrading lifts the caps to match your actual volume.
        </div>
      )}
    </div>
  );
}

export default UsageBars;